<!-- www.quickepay / Support
Edited with WebStorm
Created by maizerg on 2/19/18 at 3:21 PM
<!-->

<template>
    <div id="support">
        <quick-site-bread-crumb title="Suporte"/>
        <div class="supportArea secPdng padTopNone">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 animated">
                        <form action="#" class="serachForm">
                            <input type="search" placeholder="Algum problema? Procure a soluçāo aqui...">
                            <input type="submit" value="">
                        </form>
                    </div>
                    <div class="col-lg-7 col-lg-offset-0 col-md-10 col-md-offset-1 animated">
                        <form action="#" class="supportForm">
                            <div class="supportTitle h3">Não encontrou o que procura?
                                <span> abra um ticket agora!</span>
                            </div>
                            <div class="subTitle">
                                Garantimos uma resposta em 24 horas!
                            </div>
                            <div class="supportInput">
                                <input type="text" placeholder="Nome completo *">
                                <input type="email" placeholder="Endereço email *">
                                <div class="supportSelect">
                                    <select name="supportSelect">
                                        <option value="">Que tipo de ajuda procura?</option>
                                        <option value="host">Ajuda como comerciante.</option>
                                        <option value="domain">Ajuda como cliente.</option>
                                        <option value="other">Ajuda técnica.</option>
                                        <option value="other">Ajuda com a API.</option>
                                    </select>
                                </div>
                                <input type="text" placeholder="Assunto">
                                <textarea placeholder="Descreva o seu problema aqui neste campo..."></textarea>
                                <div class="fileInput">
                                    <span class="fileTxt">Pode carregar um ficheiro também</span>
                                    <span class="fileSpan">
<input type="file" id="file" name="file" class="inputfile"/>
<label for="file">Buscar</label>
</span>
                                </div>
                                <div class="captcha" data-toggle="tooltip" data-placement="top" title="Active-me!">
                                    <span></span>Eu não sou um robot
                                </div>
                                <input type="submit" value="Submeter">
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-5 col-lg-offset-0 col-md-8 col-md-offset-1 animated">
                        <div class="supportFaq">
                            <div class="supportTitle h3">Respostas semelhantes:</div>
                            <div class="subTitle">Como eu faço a integraçāo do meu serviço!</div>
                            <dl class="accordion style2">
                                <dt class="active">Trabalha com pagamento de clientes?</dt>
                                <br>Poderá fazer integraçāo de pagamentos com clientes, independente da fonte da conta,
                                no seu serviço da seguinte maneira:
                                Cadaste-se no <b>quickepay</b>, e logo de seguida insira o URL na sua aplicaçāo.
                                <dt>Que tipo de contas posso inserir?</dt>
                                <dd>Podera inserir qualquer tipo de conta, desde contas de carteiras moveis, contas
                                    bancarias, cartoes, etc.
                                </dd>
                                <dt>Quais é o período para densembolso do montante como comerciante?</dt>
                                <dd>A qualquer momento, desde que tenha a necessidade o cash-out, simplismente acedendo
                                    ao painel adminsitrativo
                                    do <b>quickepay</b>.
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Accordion from '../assets/js/accordion'
  import Animate from '../assets/js/animation'
  import QuickSiteBreadCrumb from '../components/site/SiteBreadCrumb'

  export default {
    components: {QuickSiteBreadCrumb},
    mounted() {
      Accordion()
      Animate()
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Support.vue